import React, { useState, useEffect } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader,
  ModalBody, ModalFooter, ModalCloseButton, Button,
  FormControl, FormLabel, Input, Select
} from '@chakra-ui/react';

type Seat = {
  _id: string;
  nome: string;
  cognome: string;
  email: string;
  telefono: string;
  prezzo: number;
  stato: string;
};

type Props = {
  seat: Seat | null;
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
};

export const EditModal = ({ seat, isOpen, onClose, onSave }: Props) => {
  const [formData, setFormData] = useState<Seat | null>(seat);

  useEffect(() => {
    setFormData(seat);
  }, [seat]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    if (!formData) return;
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    if (!formData) return;
    const token = localStorage.getItem('token');

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/seat/${formData._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      if (!res.ok) throw new Error(await res.text());

      onSave();
      onClose();
    } catch (err) {
      console.error('Error updating seat:', err);
      alert('Errore aggiornamento posto');
    }
  };

  if (!formData) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Seat</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel>Nome</FormLabel>
            <Input name="nome" value={formData.nome} onChange={handleChange} />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel>Cognome</FormLabel>
            <Input name="cognome" value={formData.cognome} onChange={handleChange} />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel>Email</FormLabel>
            <Input name="email" value={formData.email} onChange={handleChange} />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel>Telefono</FormLabel>
            <Input name="telefono" value={formData.telefono} onChange={handleChange} />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel>Prezzo</FormLabel>
            <Input name="prezzo" type="number" value={formData.prezzo} onChange={handleChange} />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel>Stato</FormLabel>
            <Select name="stato" value={formData.stato} onChange={handleChange}>
              <option value="Prenotato">Prenotato</option>
              <option value="Disponibile">Disponibile</option>
              <option value="Disabili">Disabili</option>
              <option value="Vuoto">Vuoto</option>
            </Select>
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleSubmit}>Save</Button>
          <Button variant="ghost" onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
